import { combineReducers } from 'redux';
import { uniq, without } from 'lodash/fp';
import { createReducer } from '@mews/framework';
import { createEntitiesReducer } from '@mews-commander/legacy-entities/src/ducks/utils';
import {
    CATEGORY_SELECTED,
    RESOURCES_DELETED,
    RESOURCES_UPDATED,
    FLOOR_SELECTED,
    RESOURCE_SELECTED,
    RESOURCE_DESELECTED,
    RESOURCES_DESELECTED,
    REDUCERS_RESET,
} from '../actions/types';
import { SimpleResource } from '../types';

const INITIAL_STATE: SimpleResource = {
    categoryId: null,
    floorId: null,
    index: null,
    name: null,
    resourceCategoryIndexes: null,
    selectedCategoryId: null,
    selectedFloorId: null,
};

const INITIAL_OPERATIONS_STATE: string[] = [];

const metaReducer = createReducer(INITIAL_STATE, {
    [CATEGORY_SELECTED]: (state: SimpleResource, categoryId: string) => ({
        ...state,
        selectedCategoryId: categoryId,
    }),
    [FLOOR_SELECTED]: (state: SimpleResource, floorId: string) => ({
        ...state,
        selectedFloorId: floorId,
    }),
    [REDUCERS_RESET]: () => INITIAL_STATE,
});

const operationsReducer = createReducer(INITIAL_OPERATIONS_STATE, {
    [RESOURCE_SELECTED]: (state: string[], resourceId: string) => uniq([...state, resourceId]),
    [RESOURCE_DESELECTED]: (state: string[], resourceId: string) => without([resourceId], state),
    [RESOURCES_DESELECTED]: () => INITIAL_OPERATIONS_STATE,
    [REDUCERS_RESET]: () => INITIAL_OPERATIONS_STATE,
});

const resourcesReducer = createEntitiesReducer({
    DELETE_SUCCESS: RESOURCES_DELETED,
    UPDATE_SUCCESS: RESOURCES_UPDATED,
    RESET_SUCCESS: REDUCERS_RESET,
});

export default combineReducers({
    resources: resourcesReducer,
    meta: metaReducer,
    operations: operationsReducer,
});
